<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Maquinarias</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo" :href="route('gasolineras')">
        <span>Editar</span>
        <span class="hidden md:inline">Precios</span>
      </inertia-link>
      <inertia-link v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo" :href="route('maquinarias.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Maquinaria</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Código</th>
          <th class="px-6 pt-6 pb-4">Propietario</th>
          <th class="px-6 pt-6 pb-4">Clase</th>
          <th class="px-6 pt-6 pb-4">Placas</th>
          <th class="px-6 pt-6 pb-4">Grupo</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Marca</th>
        </tr>
        <tr v-for="maquinaria in maquinarias.data" :key="maquinaria.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
              {{ maquinaria.codigo }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('maquinarias.edit', maquinaria.id)">
              {{ maquinaria.empresa_propietaria }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
                {{ maquinaria.clase }}
            </inertia-link>
          </td>
         
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
              {{ maquinaria.placas }}
            </inertia-link>
          </td>
            <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
              {{ maquinaria.grupo }}
            </inertia-link>
          </td>
            <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
              {{ maquinaria.marca }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('maquinarias.edit', maquinaria.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="maquinarias.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Maquinarias</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="maquinarias.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Maquinaria' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    maquinarias: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('maquinarias'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
